import { Moon, Sun } from "lucide-react";
import { useSTXTheme } from "@/contexts/STXThemeContext";
import { IconPill } from "@/components/toggles";

/**
 * Kleiner STX-scoped Light/Dark-Toggle (jetzt via IconPill).
 * Wird nur auf STX-Seiten sichtbar sein — Preference wird global gespeichert.
 */
export default function STXThemeToggle({ className = "" }) {
  const { mode, toggle } = useSTXTheme();
  const isDark = mode === "dark";
  return (
    <IconPill
      testId="stx-theme-toggle"
      ariaLabel={isDark ? "Zu Light-Mode wechseln" : "Zu Dark-Mode wechseln"}
      onClick={toggle}
      variant="stx"
      icon={isDark ? <Sun size={14} /> : <Moon size={14} />}
      label={isDark ? "Light" : "Dark"}
      className={className}
    />
  );
}
